<div class="container">
    <div class="stepper">
        <div class="step-list">
            <div *ngFor="let chartStep of steps; let i = index">
                <div class="step" [class.active]="chartStep.active || chartStep.completed== true"
                    [class.last]="i == (steps.length - 1)" (click)="clickStep(i)">
                    <div class="step-number" *ngIf="chartStep.completed == false" [class.active]="chartStep.active">
                        {{i + 1}}</div>
                    <div class="step-number step-check" *ngIf="chartStep.completed" [class.active]="true">
                        <i-feather class="step-check" name="check"></i-feather>
                    </div>
                    <div class="step-text" [class.active]="chartStep.active || chartStep.completed">
                        {{chartStep.name}}</div>
                </div>
                <div class="step substep" *ngFor="let chartSubstep of chartStep.substeps; let j = index"
                    [class.active]="chartSubstep.active || chartStep.completed"
                    [class.current]="chartSubstep.active && chartSubstep.completed == false"
                    [class.completed]="chartSubstep.completed" (click)="clickSubstep(i, j)">
                    <div class="substep-icon" [class.active]="chartSubstep.active"
                        [class.completed]="chartSubstep.completed"></div>
                    <div class="substep-text" [class.active]="chartSubstep.active"
                        [class.completed]="chartSubstep.completed">{{chartSubstep.name}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="options">
        <!-- Users step -->
        <div *ngIf="steps[currentStep].name == 'Users'" class="users-step">
            <!-- <app-choose-users-table *ngIf="userType === 'dealeradmin' && dealers != null" [selection]="selectedDealers"
                [dealers]="dealers" [currentOffset]="currentOffset" [currentTake]="currentTake"
                [clickstreamPageTitle]="'Push Chart - Choose Your Users'"></app-choose-users-table> -->
            <div class="subtitle1" style="font-style: italic;">Choose at least one country. All users within the chosen countries will see the chart(s) on their dashboards.</div>
            <mat-form-field appearance="fill" class="searchbox" class="choose-country-search">
                <input id="searchInput" matInput [ngModel]="countrySearchInput" placeholder="Search by country name"
                    (keyup)="searchCountries($event.target.value)">
            </mat-form-field>
            <app-data-table  *ngIf="!countriesLoading" [displayedColumns]="countryColumns" [tableData]="countries" [initSortColumn]="0" class="choose-country-table"
                        [initSortDirection]="'asc'" [selectable]="true" [selection]="selectedCountries"></app-data-table>  
            <div class="btn-container">
                <button mat-raised-button class="nav-btn" color="accent" (click)="next()"
                    [disabled]="selectedCountries.selected.length < 1" id="nextBtn">Next</button>
            </div>
        </div>
        <!-- Choose chart step  -->
        <div *ngIf="steps[currentStep].name == 'Chart'" class="step-option">
            <div class="step-title subtitle1" style="font-style: italic;">Choose at least one chart to send:</div>
            <app-admin-chart-picker [selectedCharts]="selectedCharts"></app-admin-chart-picker>
            <div class="btn-container" style="padding-top: 10px">
                <button mat-raised-button class="nav-btn" color="accent" (click)="back()">Back</button>
                <button mat-raised-button class="nav-btn" color="accent" (click)="addTimeFrameSubstep(true)"
                    [disabled]="selectedCharts.length < 1" id="nextBtn">Next</button>
            </div>
        </div>
        <!-- Time frame step -->
        <div *ngIf="steps[currentStep].name == 'Time Frame'">
            <div *ngFor="let chart of finalCharts; let i = index">
                <div *ngIf="i == this.currentSubstep" class="time-option">
                    <div class="step-title">
                        <span class="subtitle1">Set a time frame for </span> <span
                            class="subtitle7">{{chart.name}}</span><span class="subtitle1"> to show in users'
                            dashboards.</span>
                    </div>
                    <app-time-frame-picker [(timeFrame)]="chart.timeFrame"></app-time-frame-picker>
                    <div class="btn-container">
                        <button mat-raised-button class="nav-btn" color="accent" (click)="back()">Back</button>
                        <button mat-raised-button class="nav-btn" color="accent" (click)="next(); setupReviewStep()"
                            [disabled]="!chart.timeFrame.valid" id="nextBtn">Next</button>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="steps[currentStep].name == 'Review & Push'" class="step-option">
            <div class="review-container">
                <div class="step-title">
                    <div *ngIf="userType === 'dealeradmin'">
                        <span class="subtitle7 underline">
                            {{chartToReview.name}}</span> <span class="subtitle1"> will be
                            sent to will
                            be sent to the dashboards of all employees in the countries: </span>
                        <mat-list role="list" class="list-of-dealers">
                            <mat-list-item role="listitem" class="subtitle7 underline"
                                *ngFor="let country of selectedCountries.selected">{{country.fullName}}</mat-list-item>
                        </mat-list>
                        <!-- <span class="subtitle7 underline"
                        *ngFor="let dealer of selectedDealers.selected">{{dealer.name}}</span> -->
                    </div>
                </div>
                <div class="step-title">
                    <span class="subtitle1">It will show </span>
                    <span class="subtitle7">{{duration}} </span>
                    <!-- <ng-container *ngIf="timeFrameForm.startDate">
                        <span class="subtitle7">from {{timeFrameForm.startDate | date: 'shortDate'}} </span>
                    </ng-container> -->
                    <!-- <ng-container *ngIf="timeFrameForm.endDate">
                        <span class="subtitle7">to {{timeFrameForm.endDate | date: 'shortDate'}}. </span>
                    </ng-container> -->
                </div>
                <div class="charts-list-review">
                    <div *ngFor="let chart of finalCharts" class="chart-review stack-top"
                        [class.active]="chartToReview.name == chart.name" (click)="clickReviewChart(chart)">
                        <ng-container *ngIf="chartToReview.name == chart.name">
                            <!-- <div class="overlay"></div> -->
                            <app-chart [chart]="chart"></app-chart>
                        </ng-container>
                        <ng-container *ngIf="chartToReview.name != chart.name">
                            <app-chart [chart]="chart"></app-chart>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="btn-container">
                <button mat-raised-button class="nav-btn" color="accent" (click)="back()">Back</button>
                <button mat-raised-button class="nav-btn" color="accent" (click)="pushCharts()" id="pushChartsBtn">Save
                    and Push Charts
                </button>
            </div>
        </div>
    </div>
</div>